<template>
    <div class="app-payment-pix">
        <div class="app-payment-pix__content">
            <p class="app-payment-pix__content-text">
                Clique no botão abaixo para gerar manualmente o QR Code e o código.
            </p>

            <vs-row v-if="qrCode">
                <vs-col vs-sm="12" vs-md="6" vs-lg="7" vs-type="flex" vs-justify="center">
                    <qrcode-vue class="app-payment-pix__content-qrcode" :value="qrCode" :size="qrCodeSize" level="H"/>
                </vs-col>

                <vs-col vs-sm="12" vs-md="6" vs-lg="5" vs-type="flex" vs-justify="center" vs-align="center">
                    <b-button class="app-payment-pix__content-button app-payment-pix__content-button-copy"
                              @click="handleClickCopy">
                        <i class="material-icons">content_copy</i>
                        <span>Copia e cola</span>
                    </b-button>
                </vs-col>
            </vs-row>

            <b-button v-else class="app-payment-pix__content-button app-payment-pix__content-button-generate"
                      @click="handleClickGenerate">
                <span>GERAR AGORA</span>
            </b-button>
        </div>
    </div>
</template>

<script>
import QrcodeVue from "qrcode.vue"
import mixins from "@/mixins/mixins"

export default {
    name: "AppPaymentPix",

    mixins: [mixins],

    components: {
        QrcodeVue,
    },

    props: {
        qrCodeText: {
            type: String,
            default: "",
        },
        paymentError: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            qrCode: null,
            qrCodeSize: 200,
            customerData: null,
        }
    },
    watch: {
        qrCodeText(val) {
            if (val) {
                this.qrCode = val
            }
        },
        paymentError(val) {
            if (val) {
                this.$emit("clearPaymentError")
            }
        },
    },
    methods: {
        async handleClickGenerate() {
            this.$emit("setPayment")
        },
        handleClickCopy() {
            if (!this.qrCode) {
                this.showNotifyError('', 'Nenhum código Pix disponível para copiar.', 3000)
                return
            }

            const codeToCopy = this.qrCode.replace(/\/qr_code$/, '/pay')

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(codeToCopy)
                    .then(() => this.showNotifySuccess('', 'Código pix copiado com sucesso!', 3000))
                    .catch(err => this.showNotifyError(err, 5000))
            } else {
                const textArea = document.createElement("textarea")
                textArea.value = codeToCopy
                document.body.appendChild(textArea)
                textArea.select()

                try {
                    document.execCommand('copy')
                    this.showNotifySuccess('', 'Código pix copiado com sucesso!', 3000)
                } catch (err) {
                    this.showNotifyError(err, 5000)
                }

                document.body.removeChild(textArea)
            }
        }
        ,
    },
}
</script>

<style lang="scss" scoped>
.app-payment-pix {
    background-color: white;
    border-radius: 1rem;
    padding: 1.5rem 0;

    &__content {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;

        &-text {
            font-size: 1.25rem;
            color: #000D40;
        }

        &-qrcode {
            margin: 2rem 0 0;

            @media (min-width: 768px) {
                margin: 2rem 0;
            }
        }

        &-button {
            align-items: center;
            background-color: #A6E1FF;
            border-color: #A6E1FF;
            color: #0137FD !important;
            display: flex !important;
            font-size: 1rem;
            gap: .5rem;
            height: 2.5rem;
            justify-content: center;

            &:hover {
                background-color: darken(#A6E1FF, 5);
                border-color: darken(#A6E1FF, 15);
            }

            &-copy {
                margin: 1rem 0 2rem;

                @media (min-width: 768px) {
                    margin: 0;
                }
            }

            &-generate {
                border-radius: 10rem;
                width: 100%;

                @media #{$md-and-up} {
                    max-width: 400px;
                    width: 50%;
                }
            }
        }
    }
}
</style>
